enum NotificationTypes {
    NOTIFICATION_TYPE_ERROR = 'error',
    NOTIFICATION_TYPE_INFO = 'info',
    NOTIFICATION_TYPE_SUCCESS = 'success',
}

export default NotificationTypes;
